import Select from './Select';
import Option from './Option';
import OptionGroup from './OptionGroup';

Select.Option = Option;
Select.OptionGroup = OptionGroup;

export default Select;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/select/index.js
// module id = 157
// module chunks = 0